var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fst-AdminSettings"},[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.tabs),function(tab,key){return _c('el-collapse-item',{key:key,attrs:{"title":tab.title,"name":key}},[_c(tab.component,{tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }